<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        จัดการรายชื่อบริษัทของผู้ให้บริการ
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-user"></i> จัดการรายชื่อบริษัทของผู้ให้บริการ
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ประเภทการให้บริการ" prop="Connection_type" >
                            <el-select
                              v-model="formOperator.Connection_type"
                              placeholder="กรุณาเลือกประเภทการให้บริการ"
                            >
                              <el-option label="ทั้งหมด" value=""></el-option>
                              <el-option label="โทรศัพท์เคลื่อนที่" value="mobile"></el-option>
                              <el-option label="อินเทอร์เน็ตความเร็วสูงประจำที่" value="broadband"></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-3" style="margin-top:33px;">
                          <el-button type="primary" @click="search" size="mini">ค้นหา</el-button>
                        </div>
                      </div>
                    </el-form>
                    <div class="pull-right box_add" v-if="user_permission.add">
                      <button @click="Add_company" class="btn btn-info btn_custom">
                        <i class="fa fa-plus"></i> เพิ่มบริษัท
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <div class="box-body">
                  <data-tables-server
                   @query-change="loadData"
                    :data="operators"
                    :page-size="5"
                    :total="total_rows"
                    :pagination-props="{ background: true, pageSizes: [5, 10, 20] }"
                    :table-props="tableProps"
                  >
                    <el-table-column
                      sortable
                      prop="service_type"
                      label="ประเภทการให้บริการ"
                    ></el-table-column>
                    <el-table-column sortable prop="name" label="ชื่อบริษัท"></el-table-column>
                    <el-table-column sortable prop="brand_name" label="ชื่อแบรนด์"></el-table-column>
                    <el-table-column prop="logo" label="โลโก้บริษัท">
                      <template slot-scope="scope">
                        <div class="img-radius">
                          <img :src="scope.row.logo" alt />
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="color" label="โค้ดสีบริษัท">
                      <template slot-scope="scope">
                        <el-input
                          placeholder="กรุณากรอกข้อมูล"
                          v-model="scope.row.color"
                          type="color"
                          disabled
                        ></el-input>
                      </template>
                    </el-table-column>                    
                    <el-table-column label="จัดการ" align="center" width="120" fixed="right" v-if="user_permission.add || user_permission.edit || user_permission.delete">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="แก้ไข" placement="top">
                          <el-button
                          v-if="user_permission.edit"
                            size="mini"
                            type="primary"
                            @click="handleEdit(scope.row)"
                          >
                            <i class="el-icon-edit"></i>
                          </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="ลบ" placement="top">
                          <el-button
                            v-if="user_permission.delete"
                            class="custom-btn"
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.row.info)">
                            <i class="el-icon-delete-solid"></i>
                          </el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      user_permission : {
        add : false,
        edit : false,
        delete : false
      },
      selectType: [
        {
          value: "",
          label: "ทั้งหมด"
        },
        {
          value: "mobile",
          label: "โทรศัพท์เคลื่อนที่"
        },
        {
          value: "broadband",
          label: "อินเทอร์เน็ตความเร็วสูงประจำที่"
        }
      ],
      information: { phone: "" },
      loading: false,
      dialog: false,
      label_position: "top",
      data_dialog: null,
      dialogVisible: false,
      tableProps: {
        border: true
      },
      formOperator: {
        Connection_type: ""
      },
      back_upForm: { Connection_type: ""},
      data: [],
      total: null
    }
  },
  mounted(){
    const permission = JSON.parse(atob(this.$cookies.get("user_nbtc").permission)).ListOperator
    this.user_permission.add = permission.includes('add')
    this.user_permission.edit = permission.includes('edit')
    this.user_permission.delete = permission.includes('delete')
  },
  computed: {
    ...mapState({
      operators: store => store.ListOperator.operators,
      total_rows: store=> store.ListOperator.total
    })
  },
  methods: {
    ...mapActions({
      fetch_table: "ListOperator/fetch_table",
      search: "ListOperator/search",
      remove_operator: "ListOperator/remove_operator",
      update_listoperator : "ListOperator/update_listoperator"
    }),
    loadData(queryInfo) {
      this.loading = true;
      let formInfo = {
        provider_type : this.formOperator.Connection_type,
        page : queryInfo.page,
        pageSize : queryInfo.pageSize
      }
      this.fetch_table(formInfo);
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    search(){
      this.loading = true
      this.fetch_table({
        provider_type : this.formOperator.Connection_type,
        page : 1,
        pageSize : 5
      })
      setTimeout(() => {
        this.loading = false
      }, 500);
    },
    searchByType() {
      this.loading = true;
      this.formOperator.Connection_type == 'all' ? this.fetch_table() : this.search(this.formOperator)
      this.back_upForm = this.formOperator;
      setTimeout(() => {
        this.data = this.operators;
        this.total = this.total_rows;
        this.loading = false;
      }, 500);
    },
    handleEdit(row_info){
      this.update_listoperator(row_info)
      this.$router.push({ name: "Edit_ListOperator" });
    },
    handleDelete(row_id){
      this.$confirm("ลบออกจากรายชื่อบริษัท", "แจ้งเตือน", {
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        type: "warning"
      })
      .then(() => {
        this.remove_operator(row_id);
      })
      .catch(() => {});
    },
    Add_company() {
      this.$router.push({ name: "Add_ListOperator" });
    },
  }
}
</script>
<style>
.new-space-user {
  padding-top: 16px;
}
.set-box-center-user {
  margin-top: 0;
}

</style>
